import { render, staticRenderFns } from "./settled_record.vue?vue&type=template&id=9c430220&scoped=true"
import script from "./settled_record.vue?vue&type=script&lang=js"
export * from "./settled_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c430220",
  null
  
)

export default component.exports